import { useEffect, useState } from 'react'
import { profileService } from 'services'
import { IInfo } from 'interfaces/models.interface'

function useProfileInfo(setError?: (error: any) => void) {
  const [info, setInfo] = useState<IInfo>()

  useEffect(() => {
    const controller = profileService.infoProfile(setInfo, setError)
    return () => controller.abort()
  }, [setError])

  return info
}

export default useProfileInfo
